<div class="appointment-details-modal">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-notification">
      Appointment Details
    </h6>
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-item">
      <h3>Patient Name</h3>
      <p>{{ item?.patientName }}</p>
    </div>
    <div class="card-item">
      <h3>Patient Phone</h3>
      <p>{{ item?.patientPhone }}</p>
    </div>
    <div class="card-item">
      <h3>Psp Code</h3>
      <p>{{ item?.pspCode }}</p>
    </div>
    <!-- <div class="card-item">
      <h3>Patient Profile Picture</h3>
      <img *ngIf="item?.profilePicturePatient" [src]="item?.profilePicturePatient" alt="" height="50" width="50">
    </div> -->
    <div class="card-item">
      <h3>Doctor Name</h3>
      <p>{{ item?.doctorName }}</p>
    </div>
    <!-- <div class="card-item">
      <h3>Doctor Profile Picture</h3>
      <img *ngIf="item?.profilePictureDoctor" [src]="item?.profilePictureDoctor" alt="" height="50" width="50">
    </div> -->
    
    <div class="card-item">
      <h3>Status</h3>
      <p>{{ getStatusName(item?.statusId) }}</p>
    </div>
    <div class="card-item">
      <h3>Subscription Date</h3>
      <p>{{ item?.subscriptionDate?.split('T')[0] }}</p>
    </div>
    <div class="card-item">
      <h3>Appointment Date</h3>
      <p>{{ item?.creationDate?.split('T')[0] }}</p>
    </div>
    <div class="card-item">
      <h3>Appointment Time</h3>
      <p>{{ item?.appointmentTime | date:'hh:mm:ss a' }}</p>
    </div>
    <div class="card-item">
      <h3>Doctor Start Time</h3>
      <p>{{ item?.doctorStartTime | date:'hh:mm:ss a' }}</p>
    </div>
    <div class="card-item">
      <h3>Patient Start Time</h3>
      <p>{{ item?.patientStartTime | date:'hh:mm:ss a' }}</p>
    </div>
    <div class="card-item">
      <h3>End Time</h3>
      <p>{{ item?.appointmentEndTime | date:'hh:mm:ss a' }}</p>
    </div>


    <div class="card-item">
      <h3>End By</h3>
      <p>{{ item?.endBy }}</p>
    </div>
    <div class="card-item">
      <h3>Call Duration</h3>
      <p>{{ item?.callDuration }}</p>
    </div>
    <!-- <div class="card-item">
      <h3>Paid Amount</h3>
      <p>{{ item?.patientPay }}</p>
    </div>
    <div class="card-item">
      <h3>Is Problem</h3>
      <p>{{ item?.hasProblem }}</p>
    </div>
    <div class="card-item">
      <h3>Problem</h3>
      <p>{{ item?.problem }}</p>
    </div>
    <div class="card-item">
      <h3>Comment</h3>
      <p>{{ item?.comment }}</p>
    </div>
    <div class="card-item">
      <h3>Is Se7etak Doctor</h3>
      <p>{{ item?.isSe7etak }}</p>
    </div>
    <div class="card-item">
      <h3>Is Anonymous</h3>
      <p>{{ item?.isAnonymous }}</p>
    </div>
    <div class="card-item">
      <h3>Display Name</h3>
      <p>{{ item?.displayName }}</p>
    </div> -->
    <div class="card-item">
        <h3>Have Prescription</h3>
        <p>{{ item?.isHavePrescription ? 'Yes' : 'No' }}</p>
    </div>
 
    <!-- <div class="card-item">
      <h3>Reactive</h3>
      <p>{{ item?.reactive }}</p>
    </div>
    <div class="card-item">
      <h3>Refund</h3>
      <p>{{ item?.refund }}</p>
    </div> -->
  </div>
</div>
